import { render } from "./Ranking.vue?vue&type=template&id=1be3d34a&scoped=true"
import script from "./Ranking.vue?vue&type=script&lang=js"
export * from "./Ranking.vue?vue&type=script&lang=js"

import "./Ranking.vue?vue&type=style&index=0&id=1be3d34a&lang=scss&scoped=true"

import exportComponent from "/Users/emmanueledurante/Documents/Lavoro/Martech/Whappy1/whappy-app-front-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be3d34a"]])

export default __exports__